import type { PartInstanceMeasurement } from "./generated/graphql";

export const returnValueForProp = (propType: string, measurement?: PartInstanceMeasurement | null) => {
  if (!measurement) {
    return undefined;
  }
  switch (propType) {
    case "AdjustableAccelerationProperty":
    case "AdjustableAngleProperty":
    case "AdjustableAngularComplianceProperty":
    case "AdjustableAngularTorqueComplianceProperty":
    case "AdjustableForceProperty":
    case "AdjustableComplianceProperty":
    case "AdjustableIntertiaProperty":
    case "AdjustableLengthProperty":
    case "AdjustableMassProperty":
    case "AdjustableNumberProperty":
    case "AdjustablePowerProperty":
    case "AdjustablePressureProperty":
    case "AdjustableRatioProperty":
    case "AdjustableSpringRateProperty":
    case "AdjustableSteeringRackRatioProperty":
    case "AdjustableTemperatureProperty":
    case "AdjustableTorqueProperty":
    case "AdjustableTorsionRateProperty":
    case "AdjustableVolumeProperty":
      return measurement.value;
    case "AdjustableBooleanProperty":
      return measurement.booleanValue;
    case "AdjustableLocationProperty":
      return measurement.coordinates;
    case "AdjustableOrientationProperty":
      return measurement.rotation;
    case "AdjustableStringProperty":
      return measurement.stringValue;
  }

  return undefined;
};
